module.exports = __webpack_public_path__ + "img/magento-custom-development.76c11ffb.jpg";